import styles from "../styles/styles.module.css";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as FileIcon } from "../../../assets/icons/file-icon.svg";

const SurveyPageList = ({ surveyInfo, id }) => {
  const { pathname } = useLocation();

  return (
    <div className={styles["survey-page-list"]}>
      <Link
        to={`/ajustes/encuestas/${id}/inicio`}
        className={`${styles["survey-page-list-item"]} ${
          pathname.includes("inicio")
            ? styles["survey-page-list-item--active"]
            : ""
        }`}
      >
        <div className={styles["survey-page-list-item-title"]}>
          <FileIcon />
          <span>Página de inicio</span>
        </div>
      </Link>

      {surveyInfo?.surveyPages?.map((page, index) => (
        <Link
          to={`/ajustes/encuestas/${id}/pagina/${page.id}`}
          key={page.id}
          className={`${styles["survey-page-list-item"]} ${
            pathname.includes(`/pagina/${page.id}`)
              ? styles["survey-page-list-item--active"]
              : ""
          }`}
        >
          <div className={styles["survey-page-list-item-title"]}>
            <FileIcon />
            <span>Página de preguntas</span>
          </div>
          {/* <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="1"
                  danger
                  icon={<DeleteIcon />}
                  onClick={() => {
                    showAlert({
                      title: "¿Eliminar página?",
                      content:
                        "Se eliminará la página junto con todas las preguntas asociadas.",
                      onOk: async () => {
                        await deleteSurveyPage(page.id);
                        await getSurveyInfoHandler(surveyInfo.id);

                        if (page.id === Number(pageId)) {
                          const base = `/ajustes/encuestas/${id}`;
                          const url =
                            surveyInfo.surveyPages.length > 1
                              ? `${base}/pagina/${surveyInfo.surveyPages[0].id}`
                              : `${base}/inicio`;

                          navigate(url);
                        }
                      },
                    });
                  }}
                >
                  Eliminar
                </Menu.Item>
              </Menu>
            }
          >
            <Button
              style={{ width: 24, padding: 0, color: "#000" }}
              size="small"
              type="link"
              icon={<MoreHorizontalIcon />}
            />
          </Dropdown> */}
        </Link>
      ))}

      {/* <button
        disabled={loading}
        onClick={async () => {
          if (!surveyInfo) return;
          setLoading(true);
          await createNewSurveyPage(surveyInfo.id);
          await getSurveyInfoHandler(surveyInfo.id);
          setLoading(false);
        }}
        className={`${styles["survey-page-list-item"]}`}
      >
        <div className={styles["survey-page-list-item-title"]}>
          {loading ? <CustomSpin /> : <MoreIcon />}
          <span>Añadir página</span>
        </div>
      </button> */}

      <Link
        className={`${styles["survey-page-list-item"]} ${
          pathname.includes("gracias")
            ? styles["survey-page-list-item--active"]
            : ""
        }`}
        to={`/ajustes/encuestas/${id}/gracias`}
      >
        <div className={styles["survey-page-list-item-title"]}>
          <FileIcon />
          <span>Página de gracias</span>
        </div>
      </Link>
    </div>
  );
};

export default SurveyPageList;
